import React from "react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";
import { Icon, Link, Stack } from "@bookingcom/bui-react";
import { Trans } from "@bookingcom/lingojs-react";
import useProfiler from "../../../../../../../hooks/useProfiler.js";
import { track } from "@flights/et-universal";
const useOneWayCombinationInfo = (flight) => {
    const { isMobile, isDesktop } = useProfiler();
    if (!flight.oneWayCombination)
        return undefined;
    return {
        header: flight.oneWayCombination.heading,
        content: (isDesktop() && !!track("flights_funnel_new_fd_page_desktop")) ||
            (isMobile() && !!track("flights_funnel_new_fd_page_mobile")) ? (React.createElement(Trans, { tag: "flights_funnel_fd_one_way_description", variables: { start_link: "<0>", end_link: "</0>" }, components: [
                ({ children }) => (React.createElement(Link, { key: 0, href: flight.oneWayCombination?.termsUrl, text: children, attributes: {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "aria-label": `${children} (${flight.oneWayCombination?.a11y_hint})`
                    } }))
            ] })) : (React.createElement(Stack, { direction: "row", gap: 4 },
            React.createElement(Icon, { svg: InfoSignIcon, size: "large" }),
            React.createElement(Stack.Item, { grow: true },
                React.createElement(Trans, { tag: "flights_funnel_fd_one_way_description", variables: { start_link: "<0>", end_link: "</0>" }, components: [
                        ({ children }) => (React.createElement(Link, { key: 0, href: flight.oneWayCombination?.termsUrl, text: children, attributes: {
                                target: "_blank",
                                rel: "noopener noreferrer",
                                "aria-label": `${children} (${flight.oneWayCombination?.a11y_hint})`
                            } }))
                    ] }))))
    };
};
export default useOneWayCombinationInfo;
